import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Polls the live "listening now" counts map { track_id: count }.
export function useNowPlaying(intervalMs = 10000) {
  const [counts, setCounts] = useState({});
  useEffect(() => {
    let active = true;
    const load = () => api.get("/now-playing").then(({ data }) => { if (active) setCounts(data.counts || {}); }).catch(() => {});
    load();
    const i = setInterval(load, intervalMs);
    return () => { active = false; clearInterval(i); };
  }, [intervalMs]);
  return counts;
}
